import React from 'react';

type CircleCheckmarkGreenProps = {
  alt: string;
  height?: number;
  width?: number;
};

export const CircleCheckmarkGreen = ({
  alt,
  height = 16,
  width = 16,
}: CircleCheckmarkGreenProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="CircleCheckmarkGreen">{alt}</title>
    <g clipPath="url(#clip0_7444_5073)">
      <path
        d="M7.99998 1.33325C4.31998 1.33325 1.33331 4.31992 1.33331 7.99992C1.33331 11.6799 4.31998 14.6666 7.99998 14.6666C11.68 14.6666 14.6666 11.6799 14.6666 7.99992C14.6666 4.31992 11.68 1.33325 7.99998 1.33325ZM6.19331 10.8599L3.79998 8.46659C3.53998 8.20659 3.53998 7.78659 3.79998 7.52659C4.05998 7.26659 4.47998 7.26659 4.73998 7.52659L6.66665 9.44659L11.2533 4.85992C11.5133 4.59992 11.9333 4.59992 12.1933 4.85992C12.4533 5.11992 12.4533 5.53992 12.1933 5.79992L7.13331 10.8599C6.87998 11.1199 6.45331 11.1199 6.19331 10.8599Z"
        fill="#1E853B"
      />
    </g>
    <defs>
      <clipPath id="clip0_7444_5073">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
